const TOASTER = {
    AUTO_CLOSE: 3000,
    ERROR_AUTO_CLOSE: 5000, // 5 seconds for error messages
}

export default TOASTER;